import React from "react";

const Hourglass3D = () => {
    return (
        <div className="hourglass">
            <div className="top"></div>
            <div className="bottom"></div>
        </div>
    );
};

export default Hourglass3D;
